import { useTheme } from "@mui/material";
import { HeroBlock, Typography } from "@foodpilot/foods";
import { CMSPageSection, CMSSectionBlocksContent } from "src/api/client-api/cms/useGetOneContent";

type CallToAction =
    | {
          label: string;
          onClick: () => void;
      }
    | undefined;

type HeroProps = {
    section: CMSPageSection<CMSSectionBlocksContent>;
};
export const Hero = (props: HeroProps) => {
    const theme = useTheme();
    const { section } = props;
    const { blocks } = section;

    if (blocks.length === 0) {
        return <></>;
    }

    const { title, subtitle, description, ctaLink, ctaLabel, media } = blocks[0];

    const handleExternalLink = (link: string) => () => {
        if (!link) return;

        link.startsWith("http") ? window.open(link, "_blank") : window.open(`https://${link}`, "_blank");
    };

    const RenderDescription = (): JSX.Element => {
        return description ?
                <Typography
                    dangerouslySetInnerHTML={{ __html: description }}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "space-between",
                        whiteSpace: "pre-wrap",
                        "& p": {
                            whiteSpace: "pre-wrap",
                            my: theme.spacing(0),
                            a: {
                                color: theme.palette.primary[400],
                            },
                        },
                        "& hr": {
                            border: "none",
                            height: "1px",
                            backgroundColor: theme.palette.divider,
                            width: `calc(100% + ${theme.spacing(8)})`,
                            ml: theme.spacing(-4),
                            my: theme.spacing(2.25),
                        },
                        "& .label": {
                            border: `1px solid ${theme.palette.divider}`,
                            borderRadius: theme.spacing(1),
                            padding: theme.spacing(0.5, 1),
                            backgroundColor: theme.palette.grey[200],
                        },
                    }}
                />
            :   <></>;
    };

    const getCallToActionProps: () => CallToAction = () => {
        const isCallToActionLabelIsEmpty = !ctaLabel;
        const callToActionProps = {
            label: ctaLabel,
            onClick: handleExternalLink(ctaLink),
        };
        return isCallToActionLabelIsEmpty ? undefined : callToActionProps;
    };

    const callToActionProps = getCallToActionProps();
    return (
        <HeroBlock
            title={title}
            subtitle={subtitle}
            description={<RenderDescription />}
            callToAction={callToActionProps}
            imageUrl={media?.url}
        />
    );
};
